import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Tab } from '@mui/material';
import { range, uniqueId } from 'lodash';
import React, { useEffect } from 'react';
import { ConversationCardModel, ConversationTabsModel } from '../../models/conversations';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import ConversationCardLoaderAminationData from "../shared/loaders/conversations-card-loader.json";
import BlankConvCard from './blank-conversation-tab';
import ConversationInfiniteList from './conversation-infinite-list.component';

interface Props {
    conversationTabs: ConversationTabsModel[];
    DeviceHeight: number;
    toggleCardActive: (data: ConversationCardModel, index: number) => void;
    scrollRef: React.MutableRefObject<any>;
}

const ConversationTabsComponent = (props: Props) => {
    const [value, setValue] = React.useState("ActiveTab");

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            {/* <TabList onChange={handleChange} aria-label="conversation tabs" variant="fullWidth" className={`conversation-tabs`} indicatorColor="secondary">
                {props.conversationTabs.map(x => <Tab label={x.label} value={x.value} className={`conversation-tabs-btn px-0 ${x.maxSize}`} key={x.id + x.value} onClick={x.onClick} />)}
            </TabList> */}
            {props.conversationTabs.map(x => <TabPanel value={x.value} className={`${value !== x.value ? 'd-none' : 'd-flex'} flex-direction h-p-100 p-0`} key={x.id + x.label}>
                {x.isLoading ?
                    <div className='w-p-100 o-hidden br-4' style={{ height: props.DeviceHeight }}>
                        {range(1, 13).map(x => <AnimateLoader LoaderAnimation={ConversationCardLoaderAminationData} className={"conv-card-border"} key={uniqueId()} />)}
                    </div>
                    : !!x.data.length ? <ConversationInfiniteList scrollRef={props.scrollRef} ConversationCards={x.data} key={x.id} Height={props.DeviceHeight} toggleCardActive={props.toggleCardActive} /> :
                        <BlankConvCard label={x.value === "AllTab" ? "Custom" : x.label} />
                }
            </TabPanel>)}
        </TabContext>
    )
}

export default ConversationTabsComponent